import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea, Stack, SxProps, Theme } from "@mui/material";
import color from "@/style/theme/Color";
import Link from "next/link";

type KoleksiCardProps = {
  id: string;
  judul: string;
  penulis: string;
  namaJenisPustaka: string;
  namaKlasifikasi: string;
  jumlahDibaca: number;
  jumlahDisimpan: number;
  isDapatDibaca: boolean;
  isDapatDipinjam: boolean;
  sx?: SxProps<Theme> | undefined;
  key?: any;
}

const KoleksiCard = (props: KoleksiCardProps) => {

  return (
    <Card
      sx={{
        backgroundColor: color.light_gray,
        width: "100%",
        boxShadow: "none",
        display: "flex",
        textDecoration: "none",
        ...props.sx
      }}
      href={'/koleksi/' + props.id}
      component={Link}
      key={props.id}
    >
      <CardActionArea>
        <CardContent sx={{ padding: "1rem" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack>
              <Typography color="InactiveCaptionText" sx={{ fontSize: "12px" }}>
                {props["namaJenisPustaka"]}, {props["namaKlasifikasi"]}{" "}
                {(props.namaJenisPustaka === "Buku" || props.namaJenisPustaka === "Publikasi") && (
                  <span style={{ color: "green" }}>
                    Dapat Dipinjam
                  </span>
                )}
                {props.isDapatDibaca && (
                  <span style={{ color: "red" }}>
                    PDF
                  </span>
                )}
              </Typography>
              <Typography sx={{ fontWeight: "bold" }}>{props.judul}</Typography>
              <Typography >{props.penulis}</Typography>
            </Stack>
            <Stack textAlign="center">
              <Typography sx={{ fontSize: "12px" }}>
                {props["jumlahDibaca"]}
              </Typography>
              <Typography color="InactiveCaptionText" sx={{ fontSize: "12px" }}>
                dibaca
              </Typography>
              <Typography sx={{ fontSize: "12px" }}>
                {props["jumlahDisimpan"]}
              </Typography>
              <Typography color="InactiveCaptionText" sx={{ fontSize: "12px" }}>
                disimpan
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default KoleksiCard;
